import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';

import * as Utilities from '../../Utilities';
import TopicActions from './TopicActions';
import AppStore from '../../AppStore';
import AppActions from '../../AppActions';
import history from '../../history';
import RcIf from 'rc-if';
export default class OptionsFooter extends Reflux.Component {
    constructor (state) {
        super(state);
        this.store = AppStore;
    }
    handleCopyUrl = () => {
        this.urlInput.select();
        document.execCommand('copy');
    }
    handleCancel = () => {
        AppActions.disableEdition();
        if (!this.state.currentTopic._id) {
            return history.push('/new');
        }
    }
    getImage = () => {
        if (!this.state.enableEditing && this.state.currentTopicCreatorImage) {
            return this.state.currentTopicCreatorImage;
        }
        if (this.state.enableEditing && this.state.userLogged) {
            return this.state.userData.profile_image.sizeSmall;
        }
        return '/images/icons/default-big.jpg';
    }
    getName = () => {
        let anonimo = this.state.globalTopic && !this.state.enableEditing ? 'Top5.Global' : 'Anónimo';
        if (!this.state.enableEditing && this.state.currentTopic.createdBy) {
            return this.state.currentTopic.createdBy.screen_name || this.state.currentTopic.createdBy.user;
        }
        if (this.state.enableEditing && this.state.userLogged) {
            return this.state.userData.username || this.state.userData.name;
        }
        return anonimo;
    }
    render () {
        let profileRedirect = this.state.currentTopic.createdBy && !this.state.enableEditing
        ? `/p/${this.state.currentTopic.createdBy.username}`
        : '#';
        return (
          <div className='row bottomTop'>
            <div className='col l6 m6 s6'>
              <div className='UserTop'>
                {this.state.globalTopic
                  ? <div className='country-profile'><img src='/images/global-profile.svg' /></div>
                  : <div className='profileThumb'>
                    <object type='image/jpg' data={this.getImage()} className='responsive-img'>
                      <img className='imgredes-rta img-thumbnail center-block' src='/images/icons/default-big.jpg' />
                    </object>
                  </div>
                }
                <div className='profileTxt'>
                  <label>por</label>
                  <Link to={profileRedirect}>{this.getName()}
                    <span><i className='fa fa-map-marker' aria-hidden='true' />Argentina</span>
                  </Link>
                  <RcIf if={!this.state.enableEditing}>
                    <div className='infoTop'>
                      <p>{Utilities.formatDate(this.state.currentTopic.createdAt)}</p>
                    </div>
                  </RcIf>
                </div>
              </div>
            </div>
            {this.state.enableEditing &&
              <div className='btn-rankear'>
                <button className='btn-primary waves-effect waves-light' onClick={this.props.handleNewTopic}>{this.props.isCreator ? 'Confirmar edición' : 'Crear Top5!'}</button>
                <button className='btn-primary cancel-back waves-effect waves-light' onClick={this.handleCancel}>Descartar</button>
              </div>
            }
            {!this.state.enableEditing &&
              <div className='col l6 m6 s6'>
                <div className='UserBottom right-align'>
                  <TopicActions />
                  <div className={'socialShareContainer ' + this.state.socialClass}>
                    <div className='top-share'>
                      <p>Compartir</p>
                      <a target='_blank' href={'https://www.facebook.com/sharer/sharer.php?u=' + this.props.url} data-social='facebook'><i className='fa fa-facebook' aria-hidden='true' /></a>
                      <a target='_blank' href={'https://twitter.com/home?status=' + this.props.url} data-social='twitter'><i className='fa fa-twitter' aria-hidden='true' /></a>
                      <a target='_blank' href={'https://plus.google.com/share?url=' + this.props.url} data-social='google'><i className='fa fa-google-plus' aria-hidden='true' /></a>
                    </div>
                    <div className='bottom-share'>
                      <p>
                        <span><i className='fa fa-link' aria-hidden='true' /></span><input ref={(urlInput) => { this.urlInput = urlInput; }} type='text' value={this.props.url} />
                      </p>
                      <a className='copy-link' onClick={this.handleCopyUrl}>Copiar</a>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/topic/OptionsFooter.js